"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = require("axios");
var Cookies = require("js-cookie");
var tinper_bee_1 = require("tinper-bee");
/**
 * 主要是省去一次数据解析和错误代码判断
 */
// from src/common/constant.js
var ncwTokenKey = window.ncwTokenKey || "ncw-auth-token";
// from src/utils/auth.js
function getToken() {
    return Cookies.get(ncwTokenKey);
}
function setToken(token) {
    return Cookies.set(ncwTokenKey, token);
}
function removeToken() {
    return Cookies.remove(ncwTokenKey);
}
// end from
// from src/utils/index.js
function showErrorMessage(content) {
    if (!content)
        return;
    tinper_bee_1.Message.destroy();
    tinper_bee_1.Message.create({ content: content, color: "danger" });
}
function showSuccessMessage(content) {
    if (!content)
        return;
    tinper_bee_1.Message.destroy();
    tinper_bee_1.Message.create({ content: content, color: "success" });
}
// from src/utils/request.js
var service = axios_1.default.create({
    // baseURL: process.env.REACT_APP_BASE_API, // url = base url + request url
    // withCredentials: true, // send cookies when cross-domain requests
    timeout: 0,
    headers: { "Content-Type": "application/json" },
});
// request interceptor
service.interceptors.request.use(function (config) {
    // if (config.method !== 'GET' && config.headers['Content-Type'] === 'application/x-www-form-urlencoded;charset=UTF-8') {
    //     config.data = qs.stringify(config.data)
    // }
    // do something before request is sent
    var token = getToken();
    if (token) {
        // let each request carry token
        // ['ncw-auth-token'] is a custom headers key
        // please modify it according to the actual situation
        config.headers[ncwTokenKey] = token;
    }
    // 确保每次请求获取真实数据
    var url = config.url;
    if (url.indexOf("?") === -1) {
        url = url + "?t=" + Math.random();
    }
    else {
        url = url + "&t=" + Math.random();
    }
    config.url = url;
    return config;
}, function (error) {
    // do something with request error
    // let err = error || QUERY_ERROR_MSG;
    // showErrorMessage(err)
    // console.log(err) // for debug
    return Promise.reject(error);
});
// response interceptor
service.interceptors.response.use(
/**
 * If you want to get http information such as headers or status
 * Please return  response => response
 */
/**
 * Determine the request status by custom code
 * Here is just an example
 * You can also judge the status by HTTP Status Code
 */
function (response) {
    var res = response.data;
    // if the custom code is not 20000, it is judged as an error.
    if (res.code !== 200) {
        // if (res !== '') {
        //     showErrorMessage(res.msg || 'Error')
        // }
        if (res.code === 4001) {
            // to re-login
            // TODO
        }
        console.log(res.msg);
        return Promise.reject(res.msg || "Error");
    }
    else {
        return res;
    }
}, function (error) {
    // showErrorMessage(error.message) // 交个各个组件自行决定如何显示吧
    return Promise.reject(error);
});
/**
 * 请求类
 *
 * @class request
 * @description 对于axios简单封装，默认采用application/json
 */
var request = /** @class */ (function () {
    function request(url) {
        var _this = this;
        /**
         * 对象方法，GET请求
         * @returns request promise
         */
        this.get = function () {
            return service({
                url: _this.url,
                method: "get",
            });
        };
        /**
         * 对象方法，POST请求
         * @param {object} params
         * @returns request promise
         */
        this.post = function (params) {
            return service({
                url: _this.url,
                method: "post",
                data: params,
            });
        };
        this.url = url;
    }
    /**
     * 类方法
     * @param {string} url
     * @returns request promise
     */
    request.get = function (url) {
        return service({
            url: url,
            method: "get",
        });
    };
    /**
     * 类方法，POST请求
     * @param {string} url
     * @param {object} params
     * @returns request promise
     */
    request.post = function (url, params) {
        return service({
            url: url,
            method: "post",
            data: params || {},
        });
    };
    return request;
}());
exports.default = request;
